/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StatusEnum } from './StatusEnum';
import {
    StatusEnumFromJSON,
    StatusEnumFromJSONTyped,
    StatusEnumToJSON,
    StatusEnumToJSONTyped,
} from './StatusEnum';
import type { Violation } from './Violation';
import {
    ViolationFromJSON,
    ViolationFromJSONTyped,
    ViolationToJSON,
    ViolationToJSONTyped,
} from './Violation';
import type { RelatedCase } from './RelatedCase';
import {
    RelatedCaseFromJSON,
    RelatedCaseFromJSONTyped,
    RelatedCaseToJSON,
    RelatedCaseToJSONTyped,
} from './RelatedCase';
import type { Party } from './Party';
import {
    PartyFromJSON,
    PartyFromJSONTyped,
    PartyToJSON,
    PartyToJSONTyped,
} from './Party';
import type { ProsecutionRole } from './ProsecutionRole';
import {
    ProsecutionRoleFromJSON,
    ProsecutionRoleFromJSONTyped,
    ProsecutionRoleToJSON,
    ProsecutionRoleToJSONTyped,
} from './ProsecutionRole';
import type { Outcome } from './Outcome';
import {
    OutcomeFromJSON,
    OutcomeFromJSONTyped,
    OutcomeToJSON,
    OutcomeToJSONTyped,
} from './Outcome';
import type { KeyMetrics } from './KeyMetrics';
import {
    KeyMetricsFromJSON,
    KeyMetricsFromJSONTyped,
    KeyMetricsToJSON,
    KeyMetricsToJSONTyped,
} from './KeyMetrics';
import type { CourtProceeding } from './CourtProceeding';
import {
    CourtProceedingFromJSON,
    CourtProceedingFromJSONTyped,
    CourtProceedingToJSON,
    CourtProceedingToJSONTyped,
} from './CourtProceeding';
import type { SoughtPenalty } from './SoughtPenalty';
import {
    SoughtPenaltyFromJSON,
    SoughtPenaltyFromJSONTyped,
    SoughtPenaltyToJSON,
    SoughtPenaltyToJSONTyped,
} from './SoughtPenalty';

/**
 * 
 * @export
 * @interface Prosecution
 */
export interface Prosecution {
    /**
     * The main title of the case
     * @type {string}
     * @memberof Prosecution
     */
    title: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Prosecution
     */
    caseNumbers?: Array<string> | null;
    /**
     * 
     * @type {Date}
     * @memberof Prosecution
     */
    filingDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Prosecution
     */
    resolutionDate?: Date | null;
    /**
     * The status of the litigation/investigation.
     * @type {StatusEnum}
     * @memberof Prosecution
     */
    status: StatusEnum;
    /**
     * 
     * @type {number}
     * @memberof Prosecution
     */
    settlementAmount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Prosecution
     */
    judgmentAmount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Prosecution
     */
    summary?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Prosecution
     */
    detailedDescription?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Prosecution
     */
    id: number;
    /**
     * List of violations both alleged by the SEC and those ultimately established/agreed to by parties, distinguished by the is_established field
     * @type {Array<Violation>}
     * @memberof Prosecution
     */
    violations?: Array<Violation>;
    /**
     * 
     * @type {Array<Party>}
     * @memberof Prosecution
     */
    parties?: Array<Party>;
    /**
     * 
     * @type {Outcome}
     * @memberof Prosecution
     */
    outcome?: Outcome | null;
    /**
     * 
     * @type {Array<RelatedCase>}
     * @memberof Prosecution
     */
    relatedCases?: Array<RelatedCase>;
    /**
     * 
     * @type {KeyMetrics}
     * @memberof Prosecution
     */
    keyMetrics?: KeyMetrics | null;
    /**
     * 
     * @type {Array<ProsecutionRole>}
     * @memberof Prosecution
     */
    roles?: Array<ProsecutionRole>;
    /**
     * 
     * @type {Array<CourtProceeding>}
     * @memberof Prosecution
     */
    courtProceedings?: Array<CourtProceeding>;
    /**
     * List of penalties sought by the SEC, distinct from penalties ultimately imposed upon/agreed to by a party
     * @type {Array<SoughtPenalty>}
     * @memberof Prosecution
     */
    soughtPenalties?: Array<SoughtPenalty>;
    /**
     * 
     * @type {Date}
     * @memberof Prosecution
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Prosecution
     */
    updatedAt: Date;
}



/**
 * Check if a given object implements the Prosecution interface.
 */
export function instanceOfProsecution(value: object): value is Prosecution {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ProsecutionFromJSON(json: any): Prosecution {
    return ProsecutionFromJSONTyped(json, false);
}

export function ProsecutionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Prosecution {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'caseNumbers': json['case_numbers'] == null ? undefined : json['case_numbers'],
        'filingDate': json['filing_date'] == null ? undefined : (new Date(json['filing_date'])),
        'resolutionDate': json['resolution_date'] == null ? undefined : (new Date(json['resolution_date'])),
        'status': StatusEnumFromJSON(json['status']),
        'settlementAmount': json['settlement_amount'] == null ? undefined : json['settlement_amount'],
        'judgmentAmount': json['judgment_amount'] == null ? undefined : json['judgment_amount'],
        'summary': json['summary'] == null ? undefined : json['summary'],
        'detailedDescription': json['detailed_description'] == null ? undefined : json['detailed_description'],
        'id': json['id'],
        'violations': json['violations'] == null ? undefined : ((json['violations'] as Array<any>).map(ViolationFromJSON)),
        'parties': json['parties'] == null ? undefined : ((json['parties'] as Array<any>).map(PartyFromJSON)),
        'outcome': json['outcome'] == null ? undefined : OutcomeFromJSON(json['outcome']),
        'relatedCases': json['related_cases'] == null ? undefined : ((json['related_cases'] as Array<any>).map(RelatedCaseFromJSON)),
        'keyMetrics': json['key_metrics'] == null ? undefined : KeyMetricsFromJSON(json['key_metrics']),
        'roles': json['roles'] == null ? undefined : ((json['roles'] as Array<any>).map(ProsecutionRoleFromJSON)),
        'courtProceedings': json['court_proceedings'] == null ? undefined : ((json['court_proceedings'] as Array<any>).map(CourtProceedingFromJSON)),
        'soughtPenalties': json['sought_penalties'] == null ? undefined : ((json['sought_penalties'] as Array<any>).map(SoughtPenaltyFromJSON)),
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

export function ProsecutionToJSON(json: any): Prosecution {
    return ProsecutionToJSONTyped(json, false);
}

export function ProsecutionToJSONTyped(value?: Prosecution | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'case_numbers': value['caseNumbers'],
        'filing_date': value['filingDate'] == null ? undefined : ((value['filingDate'] as any).toISOString().substring(0,10)),
        'resolution_date': value['resolutionDate'] == null ? undefined : ((value['resolutionDate'] as any).toISOString().substring(0,10)),
        'status': StatusEnumToJSON(value['status']),
        'settlement_amount': value['settlementAmount'],
        'judgment_amount': value['judgmentAmount'],
        'summary': value['summary'],
        'detailed_description': value['detailedDescription'],
        'id': value['id'],
        'violations': value['violations'] == null ? undefined : ((value['violations'] as Array<any>).map(ViolationToJSON)),
        'parties': value['parties'] == null ? undefined : ((value['parties'] as Array<any>).map(PartyToJSON)),
        'outcome': OutcomeToJSON(value['outcome']),
        'related_cases': value['relatedCases'] == null ? undefined : ((value['relatedCases'] as Array<any>).map(RelatedCaseToJSON)),
        'key_metrics': KeyMetricsToJSON(value['keyMetrics']),
        'roles': value['roles'] == null ? undefined : ((value['roles'] as Array<any>).map(ProsecutionRoleToJSON)),
        'court_proceedings': value['courtProceedings'] == null ? undefined : ((value['courtProceedings'] as Array<any>).map(CourtProceedingToJSON)),
        'sought_penalties': value['soughtPenalties'] == null ? undefined : ((value['soughtPenalties'] as Array<any>).map(SoughtPenaltyToJSON)),
        'created_at': ((value['createdAt']).toISOString()),
        'updated_at': ((value['updatedAt']).toISOString()),
    };
}

